import * as React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import SendIcon from '@material-ui/icons/Send';
import Snackbar from '@material-ui/core/Snackbar';
import { LinearProgress, Tooltip, Typography } from '@material-ui/core';

import './BookstoreAnalytical.scss';
import gql from 'graphql-tag';
import { Query, ApolloConsumer } from 'react-apollo';
import { QUERY_FILTER_BOOKSTORE, QueryFilter } from '../../shared';
import { MoneyFullBRL, NumberLessBRL, MoneyBRL, NumberConvert, CurrentDate, SomeDaysAgo } from '../../../services';

// tslint:disable-next-line:no-empty-interface
export interface ITableAnalyticalPros {
}

export interface ITableAnalytical {
  count: number,
  // loading: boolean,
  endDate: any,
  initialDate: any,
  limit: number,
  offset: number,
  openSnack: boolean,
  page: number,
  rows?: any,
  snackMessage: string,
}

const QUERY_ANALYSIS_DATA_BOOKSTORE = gql`
query bookstoreAnalysisData($customFilter:  BookstoreCustomFilter) {
  bookstoreAnalysisData(bookstoreCustomFilter: $customFilter) {
    sku
    price
    description
    revenue
    volume
    price
    qty_coupon
  },
  # bookstoreCountAnalysis(bookstoreCustomFilter: $customFilter),
  bookstoreAnalysisSubTotalsData(bookstoreCustomFilter: $customFilter) {
    revenue
    price
    qty_coupon
    volume
  }
}
`;

const QUERY_FILE_REPORT = gql`
query bookstoreAnalysisData($customFilter:  BookstoreCustomFilter) {
  bookstoreGetFileReport(bookstoreCustomFilter: $customFilter)
}
`;

export class TableAnalytical
  extends React.Component<ITableAnalyticalPros, ITableAnalytical> {

  private lockFileRequest: boolean = false;

  constructor(props: ITableAnalyticalPros) {
    super(props);

    const finalDate = CurrentDate();
    const initDate = SomeDaysAgo(32);

    this.state = {
      count: 100,
      endDate: finalDate,
      initialDate: initDate,
      limit: 100,
      offset: 0,
      openSnack: false,
      page: 0,
      rows: [],
      snackMessage: "",
    }

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSnackClose = this.handleSnackClose.bind(this);
  }

  public paginacaoVirtual = (bookstoreAnalysisData: any[]) => {
    const start = this.state.offset;
    const end = start + 100;
    return bookstoreAnalysisData.slice(start, end)
  }

  public render() {
        const jsonFilter = {
          "customFilter": {
            "endDate": this.state.endDate,
            "initialDate": this.state.initialDate
          }
        };

        return (
          <div>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={this.state.openSnack}
              onClose={this.handleSnackClose}
              ContentProps={{
                'aria-describedby': 'message-id',
              }}
              message={<span id="message-id">{this.state.snackMessage}</span>}
            />
            <Query query={QUERY_FILTER_BOOKSTORE} notifyOnNetworkStatusChange={true}>
            {({ loading: loadingC, error: errorC, data: cache, client: clientC, refetch: refetchC}) => (
              <Query query={QUERY_ANALYSIS_DATA_BOOKSTORE}
               variables={QueryFilter.getFilterBookstore(clientC, jsonFilter, [])}>
                {({ loading, error, data, client, refetch}) => {

                  return (
                    <Paper className="analytical-panel">
                      <Grid container={true} className="analytical-header">
                          <Grid item={true} xs={8}>
                            <form onSubmit={this.requestByDate.bind(this, refetch, refetchC, clientC)}>
                              <div className="analytical-date">
                                  <TextField
                                    defaultValue={this.state.initialDate}
                                    id="initialDate"
                                    label="Data inicial"
                                    type="date"
                                    required={true}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                              </div>
                              <TextField
                                defaultValue={this.state.endDate}
                                id="endDate"
                                label="Data final"
                                type="date"
                                required={true}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                              <IconButton type="submit"  color="primary" >
                               <Tooltip title="Pesquisar">
                                <SendIcon/>
                                 </ Tooltip>
                                </IconButton>
                            </form>
                          </Grid>
                          <Grid item={true} xs={3}>
                              <Typography variant="body1" className="qtdDistinctPrd">
                                  {data && data.bookstoreAnalysisData ? data.bookstoreAnalysisData.length : 0} Produtos Diferentes
                              </Typography>
                          </Grid>
                          <Grid item={true} xs={1}>
                          <ApolloConsumer>
                            {clientF => (

                              <IconButton
                                color="primary"
                                className="download-button"
                                onClick={this.requestFile.bind(this, clientF, jsonFilter)}>
                                <Tooltip title="Exportar">
                                  <GetAppIcon/>
                                </ Tooltip>
                              </IconButton>
                            )}
                          </ApolloConsumer>
                          </Grid>
                      </Grid>
                    {
                      <div className="analytical-table">

                        {loading ? <LinearProgress /> :<Table>
                          <TableHead>
                            <TableRow>
                              <TableCell/>
                              <TableCell/>
                              <TableCell/>
                              <TableCell>Faturamento</TableCell>
                              <TableCell>Share</TableCell>
                              <TableCell>Preço Médio</TableCell>
                              <TableCell>Volume</TableCell>
                              <TableCell>Qtde Cupons</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell className="analytical-total padding-left" component="th" scope="row">
                                TOTAL
                              </TableCell>
                              <TableCell/>
                              <TableCell/>
                              <TableCell className="analytical-total"> {data && data.bookstoreAnalysisSubTotalsData ? MoneyFullBRL(data.bookstoreAnalysisSubTotalsData[0].revenue) :0 } </TableCell>
                              <TableCell className="analytical-total">100%</TableCell>
                              <TableCell className="analytical-total"> {data && data.bookstoreAnalysisSubTotalsData ? MoneyFullBRL(data.bookstoreAnalysisSubTotalsData[0].price) :0 } </TableCell>
                              <TableCell className="analytical-total"> {data && data.bookstoreAnalysisSubTotalsData ? NumberLessBRL(data.bookstoreAnalysisSubTotalsData[0].volume) :0 } </TableCell>
                              <TableCell className="analytical-total"> {data && data.bookstoreAnalysisSubTotalsData ? data.bookstoreAnalysisSubTotalsData[0].qty_coupon :0 } </TableCell>
                            </TableRow>
                           {
                              data && data.bookstoreAnalysisData ? this.paginacaoVirtual(data.bookstoreAnalysisData).map((row: any, key: number) => {
                              // data && data.bookstoreAnalysisData ? data.bookstoreAnalysisData.map((row: any, key: number) => {
                                return (
                                    <TableRow key={key}>
                                      <TableCell className="padding-left">{ 1 + key + (this.state.page * this.state.limit) }</TableCell>
                                      <TableCell component="th" scope="row">
                                        {row.sku}
                                      </TableCell>
                                      <TableCell>{row.description}</TableCell>
                                      <TableCell>{MoneyBRL(row.revenue)}</TableCell>
                                      <TableCell>
                                        {
                                          data && data.bookstoreAnalysisSubTotalsData && row && row.revenue ? 
                                            (NumberConvert(row.revenue)*100/NumberConvert(data.bookstoreAnalysisSubTotalsData[0].revenue)).toFixed(1)+'%':
                                            0+'%'
                                        }
                                      </TableCell>
                                      <TableCell className="analytical-cell">{MoneyBRL(row.price)}</TableCell>
                                      <TableCell>{NumberLessBRL(row.volume)}</TableCell>
                                      <TableCell>{row.qty_coupon}</TableCell>
                                    </TableRow>
                                );
                              }):<div/>
                            }
                          </TableBody>
                        </Table>}
                      </div>
                    }
                      {
                        loading ? (
                          <div className="loading-margin" />
                        ) : (
                          <TablePagination
                            component="div"
                            page={this.state.page}
                            // count={data && data.bookstoreCountAnalysis ? data.bookstoreCountAnalysis : this.state.count}
                            count={data && data.bookstoreAnalysisData ? data.bookstoreAnalysisData.length : this.state.count}
                            rowsPerPage={this.state.limit}
                            rowsPerPageOptions={[]}
                            backIconButtonProps={{
                              'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                              'aria-label': 'Next Page',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={undefined}
                          />
                        )
                      }
                    </Paper>
                  );
                }}
              </Query>
            )}
          </Query>
          </div>
    );
  }

  public requestFile(client: any, filter: any) {
    if (this.lockFileRequest) {
      return;
    }

    const deepFilter = JSON.parse(JSON.stringify(filter));

    delete deepFilter.customFilter.limit;
    delete deepFilter.customFilter.offset;

    this.lockFileRequest = true;
    this.setState({
      openSnack: true,
      snackMessage: "O relatório está sendo preparado para download",
    });

    client.query({
      fetchPolicy: 'network-only',
      query: QUERY_FILE_REPORT,
      variables: deepFilter
    }).then(() => {
      this.lockFileRequest = false;
    });
  }

  public handleSnackClose(ev: any) {
    this.setState({
      openSnack: false,
    });
  }

  public requestByDate(refetch: any, refetchC: any, clientC: any, ev: any) {
    this.setState({ page: 0, offset: 0})
    ev.preventDefault();

    QueryFilter.updateMutationBookstore();
    this.setState({
      endDate: ev.target.endDate.value,
      initialDate: ev.target.initialDate.value,

    });
  }

  public handleChangePage(ev: any, pageParam: number) {

    if (pageParam <= this.state.page) {
      this.setState({
        offset: pageParam * 100 <= 0 ? 0 : pageParam * 100,
        page: pageParam,
      });
    } else {
      this.setState({
        offset: pageParam * 100,
        page: pageParam,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/analytical/TableAnalytical.tsx